<button aria-hidden="false" mat-stroked-button class="mat-button-with-icon account-switch-button full-width">
  <div class="flex-space-between gap-6">
    <div class="flex-start-center left-aligned-section gap-8 full-width" [class.full-max-width]="!showExpanded">
      <div class="character" [style.backgroundColor]="backgroundColor">{{ firstCharacter }}</div>
      <vdw-ellipsis-label class="label" [text]="name" matTooltipPosition="below" [class.full-max-width]="!showExpanded"></vdw-ellipsis-label>
    </div>
    <mat-icon *ngIf="showExpanded" class="expand" svgIcon="solid-expand-more"></mat-icon>
  </div>
</button>
